import Constants from '../config/const';

export const openPanel = ({ options, kind }) => ({
  type: Constants.panel.open,
  options,
  kind
});

export const closePanel = (kind) => ({
  type: Constants.panel.close,
  kind
});
